/**
 * Replaces umlauts in a string.
 * @note This change is to compensate having kebab case changes in other places.
 */
const UMLAUT_REPLACEMENTS = [
  ['ä', 'a'],
  ['ö', 'o'],
  ['ü', 'u'],
  ['ß', 'ss'],
];

export const replaceUmlauts = (str: string) =>
  UMLAUT_REPLACEMENTS.reduce(
    (acc, [from, to]) => acc.replace(new RegExp(from, 'g'), to).replace(new RegExp(from.toUpperCase(), 'g'), to.toUpperCase()),
    str,
  );
